import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for fetching single product details
export const fetchProductDetail = createAsyncThunk(
  'productDetail/fetchProductDetail',
  async (productId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`https://evercorenutrition.com/ev_admin/api/products/${productId}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const productDetailSlice = createSlice({
  name: 'productDetail',
  initialState: {
    product: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    clearProductDetail: (state) => {
      state.product = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetail.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchProductDetail.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.product = action.payload;
      })
      .addCase(fetchProductDetail.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearProductDetail } = productDetailSlice.actions;

// Selectors
export const selectProductDetail = (state) => state.productDetail.product;
export const selectProductDetailStatus = (state) => state.productDetail.status;
export const selectProductDetailError = (state) => state.productDetail.error;

export default productDetailSlice.reducer;